import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

/**
 * Renderiza o alerta "um item que você comprou ganhou uma versão nova". O
 * subject é o próprio destinatário (User); nome do produto e versão vêm de
 * content() (data). Leva para "Meus downloads" para baixar a versão nova.
 */
export default class ProductVersionNotification extends Notification {
  icon() {
    return 'fas fa-arrow-up-right-dots';
  }
  href() {
    return app.route('marketplace.downloads');
  }
  content() {
    const data = this.attrs.notification.content() ?? {};
    return app.translator.trans('ramon-marketplace.forum.notifications.product_version', {
      product: data.product_name,
      version: data.version
    });
  }
  excerpt() {
    return this.attrs.notification.content()?.version ?? '';
  }
}
flarum.reg.add('ramon-marketplace', 'forum/components/ProductVersionNotification', ProductVersionNotification);